import { throttle } from 'lodash';
import { ElementScrollingModel } from './ElementScrollingModel';

export class DndWrapperModel {

  get hasReachedPinnedHeight() {
    if (!this.pinnedHeight) {
      return false;
    }
    return this.height + this.scrollTop >= this.pinnedHeight;
  }

  get top() { return this.rect.top; }
  get bottom() { return this.rect.bottom; }
  get left() { return this.rect.left; }
  get right() { return this.rect.left; }

  get height() { return this.rect.height; }
  get width() { return this.rect.width; }

  get scrollTop() { return this.element && this.element.scrollTop; }

  get rect() { return this.element ? this.element.getBoundingClientRect() : {}; }

  get isBeingScrolled() { return this._scrollingModel.isBeingScrolled; }

  element;

  pinnedHeight;

  _scroller;

  _scrollingModel;

  constructor(element) {
    this.element = element;
    this._scrollingModel = new ElementScrollingModel(element);

    this._scroller = throttle((x, y) => this.element.scrollBy(x, y), 100);
  }

  dispose = () => {
    this._scrollingModel.dispose();
    this.element = null;
  }

  scrollToTop = (y) => { this._scroller(0, -y); }
  scrollToBottom = (y) => { this._scroller(0, y); }

  isElementCrossingUpperWrapperBoundary = (elementRect) => {
    return elementRect.top <= this.top + 15 && elementRect.bottom >= this.top;
  }

  isElementCrossingLowerWrapperBoundary = (elementRect) => {
    const halfHeight = elementRect.height / 2;
    return elementRect.top <= this.bottom - halfHeight && elementRect.bottom >= this.bottom - 15;
  }

  pinElementHeight = () => {
    if (this.element) {
      this.pinnedHeight = this.element.scrollHeight;
    }
  }

  unpinElementHeight = () => {
    this.pinnedHeight = null;
  }

}
